import { Anchor } from '@design-systems/canvas-ui'
import type { Banner } from 'graphql/queries/banner/bannerQueries'

export const SYSTEM_EVENTS_SPLASH_PAGE = 'Splash page'
export const SYSTEM_EVENTS_BANNER = 'Banner'

export const convertTextToLinks = (text: string) => {
  if (!text) return text
  const urlRegex = /(https?:\/\/[^\s]+)/g
  const parts = text.split(urlRegex)

  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <Anchor
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </Anchor>
      )
    }
    return part
  })
}

export const getSplashPageBanners = (banners: Banner[] = []) =>
  banners.filter(
    (banner) => banner?.level?.description === SYSTEM_EVENTS_SPLASH_PAGE,
  )

export const shouldShowSplashPage = ({
  hasActiveSplashPageBanner,
  shouldSkipSplashPage,
  isBannerAdmin = false,
}: {
  hasActiveSplashPageBanner: boolean
  shouldSkipSplashPage: boolean
  isBannerAdmin?: boolean
}) => !shouldSkipSplashPage && hasActiveSplashPageBanner && !isBannerAdmin
